/* Florea: tillbehör på produktsidan (A), fri frakt-mätare, leveranstext och tillbehör i kundvagnen (C). */
(function () {
  if (window.__floreaTb) return;
  window.__floreaTb = true;

  function money(cents) {
    try {
      if (window.Woolman && Woolman.Utils && Woolman.Utils.formatMoney) return Woolman.Utils.formatMoney(cents, null, true);
    } catch (e) {}
    return Math.round(cents / 100) + ' kr';
  }

  function cartUrl(path) { return ((window.routes && window.routes[path]) || ''); }
  async function addToCart(id) {
    const r = await fetch((cartUrl('cart_add_url') || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    });
    const j = await r.json();
    if (!r.ok) throw j;
    const items = (j.items || []).map((i) => ({
      variantId: i.variant_id, productId: i.product_id, quantity: i.quantity,
      previousQuantity: Math.max(0, i.quantity - 1), productTitle: i.product_title, title: i.title
    }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items } }));
  }
  async function removeFromCart(id) {
    const r = await fetch((cartUrl('cart_change_url') || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: 0 })
    });
    const j = await r.json();
    if (!r.ok) throw j;
    const ci = document.querySelector('cart-items');
    if (ci && ci.renderItems) ci.renderItems();
    document.dispatchEvent(new CustomEvent('cart:update', { detail: j }));
  }

  /* A: kryssrutor under köpknappen. Ett klick lägger tillbehöret i kundvagnen direkt, ett nytt klick tar bort det.
     Färgprickar byter variant (bild, pris, namn). Är tillbehöret redan tillagt byts varianten i kundvagnen. */
  class FloreaTb extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.addEventListener('change', async (e) => {
        const c = e.target.closest('.ftb-check');
        if (!c) return;
        e.stopPropagation();
        const row = c.closest('.ftb-row');
        const id = parseInt(c.dataset.variant, 10);
        const want = c.checked;
        row.classList.add('is-loading');
        this._busy = true;
        try {
          if (want) await addToCart(id); else await removeFromCart(id);
          row.classList.toggle('is-checked', want);
        } catch (err) {
          console.error('Florea tillbehör: kunde inte uppdatera kundvagnen', err);
          c.checked = !want;
        } finally {
          row.classList.remove('is-loading');
          this._busy = false;
        }
      });
      this.addEventListener('click', (e) => {
        const dot = e.target.closest('.ftb-dot');
        if (!dot) return;
        e.preventDefault();
        e.stopPropagation();
        this.pick(dot, true);
      });
      const sync = () => this.sync();
      document.addEventListener('ajaxProduct:added', sync);
      document.addEventListener('cart:update', sync);
      this.querySelectorAll('.ftb-check:checked').forEach((c) => c.closest('.ftb-row').classList.add('is-checked'));
    }
    show(row, dot) {
      row.querySelectorAll('.ftb-dot').forEach((d) => {
        const on = d === dot;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const name = row.querySelector('.ftb-swname');
      if (name) name.textContent = dot.dataset.name || '';
      const price = row.querySelector('.ftb-price');
      if (price && dot.dataset.price) price.textContent = dot.dataset.price;
      const img = row.querySelector('.ftb-img img');
      if (img && dot.dataset.img) {
        img.src = dot.dataset.img;
        if (dot.dataset.srcset) img.srcset = dot.dataset.srcset;
      }
      row.querySelector('.ftb-check').dataset.variant = dot.dataset.variant;
    }
    async pick(dot, user) {
      const row = dot.closest('.ftb-row');
      const c = row.querySelector('.ftb-check');
      const prev = c.dataset.variant;
      if (prev === dot.dataset.variant) return;
      this.show(row, dot);
      if (!user || !c.checked) return;
      row.classList.add('is-loading');
      this._busy = true;
      try {
        await removeFromCart(parseInt(prev, 10));
        await addToCart(parseInt(dot.dataset.variant, 10));
      } catch (err) {
        console.error('Florea tillbehör: kunde inte byta variant', err);
      } finally {
        row.classList.remove('is-loading');
        this._busy = false;
        this.sync();
      }
    }
    sync() {
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        if (this._busy) return this.sync();
        fetch((cartUrl('cart_url') || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const ids = (cart.items || []).map((i) => String(i.variant_id));
            this.querySelectorAll('.ftb-check').forEach((c) => {
              const row = c.closest('.ftb-row');
              const all = String(c.dataset.variants || c.dataset.variant).split(',');
              let hit = ids.indexOf(String(c.dataset.variant)) !== -1 ? String(c.dataset.variant) : all.find((v) => ids.indexOf(v) !== -1);
              if (hit && hit !== String(c.dataset.variant)) {
                const dot = row.querySelector('.ftb-dot[data-variant="' + hit + '"]');
                if (dot) this.show(row, dot);
              }
              c.checked = !!hit;
              row.classList.toggle('is-checked', !!hit);
            });
          })
          .catch(() => {});
      }, 250);
    }
  }
  if (!customElements.get('florea-tb')) customElements.define('florea-tb', FloreaTb);

  /* Fri frakt-mätare på produktsidan: räknar bara det som redan ligger i kundvagnen. Uppdateras när något läggs till eller tas bort. */
  class FloreaFrakt extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.threshold = parseInt(this.dataset.threshold, 10);
      this.cartTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      this.text = this.querySelector('.ffs-text');
      this.track = this.querySelector('.ffs-track');
      this.bar = this.querySelector('.ffs-bar');
      const refresh = () => this.refresh();
      document.addEventListener('ajaxProduct:added', refresh);
      document.addEventListener('cart:update', refresh);
      window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
      this.update();
    }
    refresh() {
      const url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => {
          this.cartTotal = c.total_price || 0;
          this.update();
        })
        .catch(() => {});
    }
    update() {
      if (!this.threshold) return;
      const total = this.cartTotal;
      const pct = Math.max(0, Math.min(100, Math.round((total / this.threshold) * 100)));
      this.bar.style.width = pct + '%';
      this.track.setAttribute('aria-valuenow', String(pct));
      const s = window.cartStrings || {};
      if (total > this.threshold) {
        this.classList.add('is-free');
        this.text.innerHTML = s.shipping_free || '';
      } else {
        this.classList.remove('is-free');
        this.text.innerHTML = (s.shipping_not_free || '[amount]').replace('[amount]', money(this.threshold - total));
      }
    }
  }
  if (!customElements.get('florea-frakt')) customElements.define('florea-frakt', FloreaFrakt);

  /* Leveranstext: Stockholmstid, brytpunkt, helger och stängda dagar. */
  class FloreaShip extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      let d;
      try { d = JSON.parse(this.querySelector('script').textContent); } catch (e) { return; }
      const txt = FloreaShip.text(d);
      if (!txt) return;
      this.querySelector('.fsh-text').textContent = txt;
      this.hidden = false;
    }
    static text(d) {
      if (d.dates) return FloreaShip.dateText(d);
      const p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
      const DAY = 86400000;
      const today = Date.UTC(+p.year, +p.month - 1, +p.day);
      const now = (+p.hour) * 60 + (+p.minute);
      const cutParts = String(d.cut || '12:00').split(':');
      const cut = (+cutParts[0]) * 60 + (+cutParts[1] || 0);
      const closed = d.closed || [];
      const iso = (t) => new Date(t).toISOString().slice(0, 10);
      const workday = (t) => { const w = new Date(t).getUTCDay(); return w !== 0 && w !== 6 && closed.indexOf(iso(t)) === -1; };
      const t = d.t || {};
      if (workday(today) && now < cut) return t.idag;
      let next = today + DAY, guard = 0;
      while (!workday(next) && guard < 40) { next += DAY; guard++; }
      const diff = Math.round((next - today) / DAY);
      const wd = new Date(next).getUTCDay();
      if (wd === 1 && t.mandag) return t.mandag;
      if (diff === 1) return t.imorgon;
      let loc = String(d.loc || 'sv');
      if (loc === 'no') loc = 'nb';
      let name;
      try { name = new Intl.DateTimeFormat(loc, { weekday: 'long', timeZone: 'UTC' }).format(new Date(next)); }
      catch (e) { name = new Intl.DateTimeFormat('sv', { weekday: 'long', timeZone: 'UTC' }).format(new Date(next)); }
      return (t.senare || '[dag]').replace('[dag]', name);
    }
  }
  /* Preorder Norge: nästa utskicksdatum (idag eller senare, Stockholmstid). */
  FloreaShip.dateText = function (d) {
    const p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
    const today = p.year + '-' + p.month + '-' + p.day;
    const next = (d.dates || []).slice().sort().find((x) => x >= today);
    if (!next) return null;
    let loc = String(d.loc || 'sv');
    if (loc === 'no') loc = 'nb';
    let s;
    try { s = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(next + 'T00:00:00Z')); }
    catch (e) { s = next; }
    return (d.text || '[datum]').replace('[datum]', s);
  };
  if (!customElements.get('florea-ship')) customElements.define('florea-ship', FloreaShip);

  /* C: plus-knapp på tillbehör i kundvagnen. */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest && e.target.closest('.fct-add');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    try {
      await addToCart(parseInt(b.dataset.variant, 10));
    } catch (err) {
      console.error('Florea tillbehör: kunde inte lägga till', err);
      b.classList.remove('is-loading');
    }
  }, true);
})();

/* C: ladda om tillbehören i kundvagnen när den ändras. */
(function () {
  if (window.__floreaCartTb) return;
  window.__floreaCartTb = true;
  let timer;
  function reload() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const holders = document.querySelectorAll('[data-florea-cart-tb]');
      if (!holders.length) return;
      const base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base + '?section_id=florea-cart-tillbehor')
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('.fct');
          holders.forEach((h) => { h.innerHTML = fresh ? fresh.outerHTML : ''; });
        })
        .catch(() => {});
    }, 150);
  }
  document.addEventListener('ajaxProduct:added', reload);
  document.addEventListener('cart:update', reload);
})();
